import React from 'react'

const IconMXClose = ({ width = '24', height = '24' }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M13,2 L13,11 L22,11 L22,13 L12.999,13 L13,22 L11,22 L10.999,13 L2,13 L2,11 L11,11 L11,2 L13,2 Z"
        fillRule="nonzero"
        transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
      />
    </g>
  </svg>
)

export default IconMXClose
